import 'twin.macro'

import Banner from 'components/views/Landing/Banner'
import Benefits from 'components/views/Landing/Benefits'
import Faq from 'components/views/Landing/Faq'
import GiftCard from 'components/views/Landing/GiftCard'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { api } from 'redux/api'
import { PURGE } from 'redux-persist'

function Landing() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: PURGE, result: () => null })
    api.util.resetApiState()
  }, [dispatch])

  return (
    <div tw='flex flex-col gap-20'>
      <Banner />
      <Benefits />
      <GiftCard />
      <Faq />
    </div>
  )
}

export default Landing
